import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntilDestroy} from "@ngneat/until-destroy";
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams, RowNode} from "ag-grid-community";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {EntityScopeEnum} from "@docma-mm-core/entity/entity-scope.enum";


@UntilDestroy()
@Component({
  selector: 'mydocma-mm-layout-filter-scope-cell-renderer',
  templateUrl: './layout-filter-scope-cell-renderer.component.html',
  styleUrls: ['./layout-filter-scope-cell-renderer.component.scss']
})
export class LayoutFilterScopeCellRendererComponent implements ICellRendererAngularComp, OnInit, OnDestroy {

  formGroup: UntypedFormGroup;
  scope: EntityScopeEnum;
  scopes = EntityScopeEnum;
  node: RowNode;
  colId: string;

  constructor(private readonly formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.scope = params.value;
    this.node = params.node;
    this.colId = params.column.getColId();

    this.formGroup = this.formBuilder.group({
      scope: [this.scope]
    });
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}


